module.exports = __webpack_public_path__ + "static/media/marca_admin.f9c4d1ef.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/CallRecord/marca_admin.svg
// module id = 1744
// module chunks = 0